import { create } from "zustand";
import { persist } from "zustand/middleware";

interface TokenState {
	token?: string;
	TokenUpdate: (token: string) => void;
	TokenReset: () => void;
}

export const useTokenStore = create(
	persist<TokenState>(
		(set) => ({
			token: undefined,
			TokenUpdate: (token) => {
				set({ token });
			},
			TokenReset: () => {
				set({ token: undefined });
			},
		}),
		{
			name: "local_auth", // имя ключа в localStorage
		}
	)
);
